/**
 * Takes response from the server and transforms it into data that is required
 * by the component that renders news.
 * @param data
 * @returns {
 *     results: [
 *         {
 *              title: String,
 *              description: String,
 *              thumbnail: String,
 *              href: String,
 *              featured: Boolean,
 *              stamp: Boolean,
 *          }
 *     ],
 *     total: Number,
 * }
 */
export default function (data) {
  // we need to try to catch the error cause the route returns error with code 200
  // in case we did not get json data then we just return this as an error
  // this is a temporary solution for this problem.
  try {
    if (typeof data === "object") {
      const results = data.map((item) => {
        return {
          title: item.title,
          description: item.description,
          thumbnail: item.image,
          href: item.slug,
          featured: Boolean(item.featured),
          stamp: Boolean(item.stamp)
        }
      });
      return {results: results, total: results.length};
    }
    if (typeof data === "string") return JSON.parse(data);
  }
  catch (err) {
    console.error(err);
    throw new Error(data);
  }

  return data;
}
